import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {BackNavigationService} from '../../../services/back-navigation.service';

@Component({
  selector: 'homey-back-button',
  templateUrl: './back-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackButtonComponent {
  private readonly backNavigation = inject(BackNavigationService);

  public onBackClick(): void {
    this.backNavigation.navigateBack();
  }

  protected readonly dt = {
    root: {
      primary: {
        hover: {
          background: '{surface.100}',
          color: 'black',
          border: {
            color: '{surface.100}'
          }
        },
        active: {
          background: '{surface.200}',
          color: 'black',
          border: {
            color: '{surface.200}'
          }
        },
        background: 'white',
        color: 'black',
        border: {
          color: 'white'
        }
      },
    },
  };
}
